<template>
  <section>
    <div style="width: 100%;text-align: right; margin-bottom: 10px">
      <el-button v-if="contractIds && contractIds.length > 0" type="primary" @click="lookContract">查看合同</el-button>
      <el-button type="primary" @click="printApply">打印</el-button>
    </div>
     <div id="dataform">
      <ExternalAccountRequest :apply-obj="applicationForm" ref="externalAccount"></ExternalAccountRequest>
    </div>
    <el-form>
      <el-form-item style="width: 100%;text-align: right;">
        <el-button style="margin-right: 30px;margin-top: 15px" type="primary" round v-if="datas && datas.btnIsShow && datas.nodeId == '80' " @click="uploadBackRecord(applicationForm && applicationForm.processId)">上传回执单</el-button>
        <el-button style="margin-right: 30px;margin-top: 15px" type="primary" round v-if="datas && applicationForm && applicationForm.receiptPicUrl && (!datas.btnIsShow || datas.nodeId != '80' )" @click="uploadBackRecord(applicationForm && applicationForm.processId)">查看回执单</el-button>
      </el-form-item>
    </el-form>
      <!--   -->
    <div class="checkAccount" v-if="checkedSettlement ==2 && accountlist.length > 0 && datas.btnIsShow && (datas.nodeId == '80' || datas.nodeId == '90')">
      <div style="margin: 10px 0"></div>
      <div style="display: flex;justify-content: left;align-items: center;">
        <div style="font-size: 14px;color: #6A6C70;">{{datas.nodeId == '80'?'选择付款账户：':'付款账户：'}}</div>
      </div>
      <div>
        <el-table
          ref="singleTable"
          :data="datas.nodeId == '80'?accountlist:choseAccountlist"
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%">
          <el-table-column fixed align="center" property="type" label="账户类型" ></el-table-column>
          <el-table-column align="center" property="bankName" label="银行名称"></el-table-column>
          <el-table-column align="center" property="accountName" label="账户名称" width="120px"></el-table-column>
          <el-table-column align="center" property="accountNumber" label="账户号"></el-table-column>
          <el-table-column align="center" property="initializationMoney" label="初始化余额"></el-table-column>
        </el-table>
      </div>
    </div>
    <div v-show="payType=='goodsCostOut'">

      <div style="text-align: center;margin-top:5px;">合同信息</div>
        <el-table
          ref="goodsCostOutTable"
          :data="heTongInfoList"
          highlight-current-row
          style="width: 100%"
          >
          <el-table-column align="center" property="shipName" label="船名" ></el-table-column>
          <el-table-column align="center" property="epartureTimeDate" label="离港日期" ></el-table-column>
          <el-table-column align="center" property="supplierName" label="供应商" ></el-table-column>
          <el-table-column align="center" property="costName" label="类型"  ></el-table-column>
          <el-table-column align="center" property="tonnage" label="吨位" ></el-table-column>
          <!-- <el-table-column align="center" property="priceNo" label="单价" ></el-table-column> -->
          <el-table-column align="center" property="money" label="金额" ></el-table-column>

          <el-table-column align="center"  label="合同" >
            <template slot-scope="scope">
              <el-button v-if="scope.row.contractFileUrls" @click="showFiles(scope.row.contractFileUrls)">查看</el-button>
              <span v-else style="color: red;">未关联</span>
            </template>
          </el-table-column>
          </el-table>
    </div>
    <div v-show="payType=='carCost'">
      <div style="text-align: center;margin-top:5px;">汽运信息</div>
      <el-table
        ref="carCostOutTable"
        :data="heTongInfoList"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column align="center" property="guazhanghao" label="挂账号" ></el-table-column>
        <el-table-column align="center" property="ship_name" label="船名" ></el-table-column>
        <el-table-column align="center" property="fukuanjine" label="付款金额" ></el-table-column>
        <el-table-column align="center" property="dunshu" label="吨数"  ></el-table-column>
        <el-table-column align="center" property="shourudanjia" label="收入单价" ></el-table-column>
        <!-- <el-table-column align="center" property="priceNo" label="单价" ></el-table-column> -->
        <el-table-column align="center" property="qichedanjiaStr" label="汽运单价" ></el-table-column>
        <el-table-column align="center" property="tihuofei" label="提货费" ></el-table-column>
        <el-table-column align="center" property="rirundanjia" label="利润单价" ></el-table-column>

        <el-table-column v-if="false" align="center"  label="合同" >
          <template slot-scope="scope">
            <el-button v-if="scope.row.contractFileUrls" @click="showFiles(scope.row.contractFileUrls)">查看</el-button>
            <span v-else style="color: red;">未关联</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-show="isFanDian && fanDianInfoList && fanDianInfoList.length>0">
     <div style="text-align: center;">业务成本客户信息</div>
      <el-table
          ref="fanDianTable"
          :data="fanDianInfoList"
          highlight-current-row
          style="width: 100%"
          >
          <el-table-column align="center" property="tonnage" label="运量/吨" width="80px" ></el-table-column>
          <el-table-column align="center" property="price" label="海运费收入(9%)" width="90px">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}
               <span v-if="scope.row.taxRateStr!='9%'">({{ scope.row.taxRateStr }})</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" property="price" label="代理费收入(6%)" width="90px">
            <template slot-scope="scope">
              <span>{{ scope.row.agencyFee }}
                <span v-if="scope.row.agencyFeeTaxRateStr!='6%'">({{ scope.row.agencyFeeTaxRateStr }})</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="200px" label="单吨成本(税率)" >
            <template slot-scope="scope">
              <table style="width: 100%;">
                <tr v-for="(sitem,sidx) in scope.row.incomeCostList" :key="sidx">
                  <td style="min-width:70px;">收入：{{sitem.type}} <span v-if="sitem.taxRateStr">({{ sitem.taxRateStr }})</span> </td>
                  <td style="min-width:70px;">{{sitem.price}}</td>
                </tr>
                <tr>
                  <td style="min-width:70px;">租船价<span v-if="scope.row.seaFreightTaxRateStr">({{ scope.row.seaFreightTaxRateStr }})</span> </td>
                  <td style="min-width:70px;">{{ scope.row.seaFreight }}</td>
                </tr>
                <tr v-for="(sitem,sidx) in scope.row.collCostList" :key="sidx">
                  <td style="min-width:70px;">{{sitem.type}}<span v-if="sitem.taxRateStr">({{ sitem.taxRateStr }})</span> </td>
                  <td style="min-width:70px;">{{sitem.price}}</td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column align="center" property="rebatePrice" label="返款" ></el-table-column>
          <el-table-column align="center" property="rebateTax" label="返款对应增值税"  ></el-table-column>
          <el-table-column align="center" property="totalCost" label="成本合计" ></el-table-column>
          <el-table-column align="center" property="profitPerTon" label="单吨利润" ></el-table-column>
          <el-table-column align="center" property="totalProfit" label="利润额" ></el-table-column>
          <el-table-column align="center"  label="合同" width="80px" >
            <template slot-scope="scope">
              <el-button v-if="scope.row.contractFileUrls" @click="showFiles(scope.row.contractFileUrls)">查看</el-button>
              <span v-else style="color: red;">未关联</span>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <el-dialog
      class="xuanxiang"
      :title="datas && datas.btnIsShow?'上传回执单':'查看回执单'"
      :visible.sync="showUpload"
      width="60%"
      :before-close="handleClose"
      :close-on-click-modal=false
      :append-to-body="true"
    >
      <div style="width: 100%;text-align: left;">
        <el-upload
          ref="aaaa"
          accept=".jpg,.png,.gif,.jpeg,.bmp"
          :file-list="fileList"
          :action="uploadUrl"
          list-type="picture-card"
          :before-remove="handleRemove"
          :on-error="uploadError"
          :on-success="uploadSuccess"
          :before-upload="beforeAvatarUpload"
          :on-preview="handlePictureCardPreview"
          :class="datas &&!datas.btnIsShow?'hiddenClass':''"
          :disabled="datas &&!datas.btnIsShow"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible"
        >
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer" v-if="datas && datas.btnIsShow">
                <el-button type="primary" @click="submitPic(applicationForm && applicationForm.processId)">提交</el-button>
            </span>
    </el-dialog>
    <el-dialog
      title="合同预览"
      width="40%"
      :visible.sync="showContractPreview"
      v-loading="contractPreviewLoading"
      :append-to-body="true">
      <el-button v-if="contractList.length === 0" type="primary" @click="lookContract">查看合同</el-button>
      <div class="contract-image__preview" v-else>
        <el-image
          v-for="(it,index) in contractList.map(item => item.previewFileUrl)"
          :key="index"
          :src="it"
          :preview-src-list="contractList.map(item => item.previewFileUrl)">
        </el-image>
      </div>
    </el-dialog>
    <el-image-viewer
          :zIndex="9999"
          v-if="imgViewerVisible"
          :on-close="closeImgViewer"
          :url-list="imgList" />
  </section>
</template>

<script>
  import {ERR_OK, UPLOAD_URL} from "../../jslib/config";
    import {getPayment,fanDianCustomerInfo,heTongInfo, getReceiptPicUrl, updateReceiptPicUrl} from "../../api/PaymentApply";
    import ExternalAccountRequest from "../../components/approval/ExternalAccountRequest"
    import {getUser} from "../../api/user";
    import {fmtDictionary} from "../../jslib/util";
    import {getDictionaryList} from "../../api/sysdictionary";
  import {selectbycode,selectbyId} from "../../api/sysaccount";
import { getContractByIds } from '../../api/contract'

    export default {
        name: "PaymentApprove",
        props: {
          datas: {
            type: Object
          },
          applyObj:{
            type: Object
          }
        },
      data(){
        return {
          showFile:false,
          contractPreviewLoading: false,
          showContractPreview: false,
          contractList: [],
          contractIds: null,
          baseComponent: null,
          checkedSettlement:null,
          receiveCompanyList:[],
          accountlist:[],
          choseAccountlist:[],
          currentRowId:null,
          tableData:[],
          dictionaryLists:[],
          applicationForm:{
            processId:null,
            dingjin:0,
            isApplyRecord:false,
            inter:{},
            exter:{
              businessType:null,
            },
            totalExterAmount:0,
            user:null,
            invoiceCompany:null,
            remark:null,
          },
          deductList:[],
          inOutSwitch:false,
          fileList:[],
          uploadUrl: UPLOAD_URL,
          picList:[],
          dialogImageUrl: '',
          dialogVisible: false,
          showUpload: false,
          isFanDian: false,
          fanDianInfoList: [],
          imgList: [],
          imgViewerVisible: false,
          payType:'',
          heTongInfoList:[]
        }
      },
      beforeDestroy() {
        document.removeEventListener('paste', this.onPasteUpload)
  },
  beforeUpdate() {
    if (this.datas && this.datas.params7=='fandian' || this.applyObj && this.applyObj.modelCode=='fandian') {
          this.isFanDian = true
        } else {
          this.isFanDian = false
        }
    // console.log('beforeUpdate',this.isFanDian,this.applyObj,this.datas)
      },
  mounted() {
        getDictionaryList("cost_type,contract_company").then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.dictionaryLists = res.map
            this.receiveCompanyList = res.map['contract_company']
            this.$nextTick(function () {
              this.getData()
            })
          }
        })
        this.$nextTick(() => {
          if (this.$refs.externalAccount) {
            this.$refs.externalAccount.baseComponent = this.$parent.$parent
          }
        })
        this.$on('onBeforeSubmit', (cb) => {
          let success = true
          this.$refs.externalAccount.$emit('onBeforeSubmit', (res) => {
            success = res
          })
          if (!success) {
            cb(false)
            return
          }

          cb(this.beforeSubmit())
        })
      },
  methods: {
    closeImgViewer() {
      this.imgViewerVisible = false
    },
    showFiles(urls) {
      if (urls) {
          this.imgList = urls ? urls.split(',') : []
          if (this.imgList.length == 0) {
            this.$message({
              message: '暂无附件',
              type: 'warning'
            });
            return
          }
          // 如何文件不是图片 直接下载
          let isImg = true
          this.imgList.forEach(item => {
            if (item.indexOf('.jpg') > -1 || item.indexOf('.png') > -1 || item.indexOf('.jpeg') > -1) {

            } else {
              isImg = false
            }
          })
          if (!isImg) {
            for (let i = 0; i < this.imgList.length; i++) {
              // this.downloadFile(this.imgList[i], this.imgList[i].substring(this.imgList[i].lastIndexOf('/') + 1, this.imgList[i].length))
              // 直接打开
              // this.openUrl(this.imgList[i], this.imgList[i].substring(this.imgList[i].lastIndexOf('/') + 1, this.imgList[i].length))
              // 如果是pdf 添加前缀 http://pdfjs.hy956.cn/web/viewernew.html?file=
              // window.open(this.imgList[i],'_blank')
              if(this.imgList[i].indexOf('.pdf') > -1){
                this.imgList[i] = 'https://pdfjs.hy956.cn/web/viewer.html?file=' + this.imgList[i]+"&v=1"
              }
              window.open(this.imgList[i],'_blank')
            }
            return
          }
          this.imgViewerVisible = true
        return
      }
      this.$message({
                    type: 'info',
                    message: '无合同信息'
                });
    },
    loadFanDianInfo(idArr) {
      this.fanDianInfoList = []
      if (this.isFanDian && idArr && idArr.length > 0) {
        fanDianCustomerInfo({
          costAggregationIds: idArr.join(',')
        }).then(({ data }) => {
          if (data) {
            this.fanDianInfoList = data
          }
        })
      }
    },
    loadHeTongInfo(costAddIds, type) {
      this.heTongInfoList = []
      if(type && costAddIds && costAddIds.length > 0 ) {
        heTongInfo({
          costAggregationIds: costAddIds.join(','),
          type:type
        }).then(({data}) => {
          this.heTongInfoList = data
        })
      }
    },
    showHeTong() {

    },
        lookContract() {
          this.showContractPreview = true
          this.contractPreviewLoading = true
          console.log(this.contractIds)
          getContractByIds({
            ids: this.contractIds.join(',')
          }).then(({data}) => {
            console.log(data.data)
            this.contractList = data.data
          }).catch(err => {

          }).finally(() => {
            this.contractPreviewLoading = false
          })
        },
        printApply() {
             let checkEle = window.document.getElementsByClassName('checkInput2')
            checkEle[0].setAttribute('value', checkEle[0].value)
          const divEl = document.getElementById('dataform')
          const str = window.document.getElementById('dataform').innerHTML
          const myWindow=window.open('','')
          var link = myWindow.document.createElement("link");

          var style = myWindow.document.createElement('style');
          style.innerHTML=`
          .price-table, .record-table{
            width: 100%;
          }

          td{
            width: 5%;
            text-align: center;
            height: 25px;
            color: #606266;
          }

          .record-title{
            width: 100%;
            text-align: center;
            font-size: 1.2rem;
          }
          .record-table{
            width: 100%;
          }
          .table-title{
            width: 15%;
          }
          .td-func{
            width: 10%;
          }
          .td-address{
            width: 15%;
            text-align: right;
          }
          .td-checkbox{
            text-align: left;
          }
          .row-price{
            height: 20px;
          }
          .price-table{
            width: 100%;
          }
          .td-mar{
            width: 25%;
          }
          .checkInput{
            height: 15px;
            border-left: none;
            border-right: none;
            border-top: none;
            border-bottom: #A8A8A9 1px solid;
            text-align: center;
          }
          .checkInput2{
            width: 80px;
            height: 15px;
            border-left: none;
            border-right: none;
            border-top: none;
            border-bottom: #A8A8A9 1px solid;
            text-align: center;
          }
          .checkInput3{
            border: none;
            margin-left: 40px;
          }
          .el-checkbox.is-disabled span.el-checkbox__label.el-checkbox__label{
            font-weight: normal;
            color: #606266;
          }
          .el-checkbox__input.is-disabled .el-checkbox__inner.el-checkbox__inner, .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner.el-checkbox__inner {
            border-color: #bdbdbd;
            background-color: transparent;
            border-radius: 0;
          }
          .el-checkbox__input.is-disabled.is-checked.is-checked .el-checkbox__inner::after {
            border-color: #606266;
            height: 18px;
            width: 7px;
            border-width: 3px;
            top: -7px;
            left: 2px;
          }
          .pt-show {
            display: none;
          }
          .pt-print {
            display: initial;
          }
          `;
          myWindow.document.getElementsByTagName('head').item(0).appendChild(style);

          link.rel = "stylesheet";
          link.type = "text/css";
          // TODO 后面需要把css缓存到自己的oss上
          link.href = "https://unpkg.com/element-ui/lib/theme-chalk/index.css";
          myWindow.document.getElementsByTagName("head")[0].appendChild(link);
          link.onload = () => {
            myWindow.print();
          };
          myWindow.document.body.innerHTML = divEl.innerHTML;
        },
        beforeSubmit() {
          return true
        },
        onPasteUpload(e) {
          const upload = this.$refs.aaaa
          if (!upload) {
            return
          }
          const items = e.clipboardData.items
          for (const item of items) {
            if (item.type === 'image/png') {
              const file = new File([item.getAsFile()], new Date().getTime() + '.png')
              upload.handleStart(file)
            }
          }
          upload.submit()
        },
        handleCurrentChange(val) {
          if(this.datas.nodeId == '80'){
            this.currentRowId = val.id;
          }
        },
        selecRreceiveCompany(code){
          selectbycode(code).then(res =>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.accountlist = res.list
            }
          })
        },
        selectAccountById(){
          this.currentRowId = this.datas.formValue.accountId
          selectbyId(this.datas.formValue.accountId).then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.choseAccountlist = res.list
            }
          })
        },
        handleClose(){
          this.showUpload = false
          this.fileList = []
          this.picList = []
        },
        submitPic(id){
          var query = {
            processId:id,
            picList:this.picList.toString()
          }
          updateReceiptPicUrl(query).then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.$message.success(`回执单上传成功！`)
              var param = {
                processId:id
              }
              processApi.sendMessage(param).then(res=>{})
            }
          }).finally(this.handleClose())
        },
        toremove(file, fileList){
          if(file.response != undefined && file.response != null && file.response != ""){
            console.info(file,fileList)
            var list = Object.assign([],this.picList)
            this.picList = []
            for(var i=0;i<list.length;i++){
              if(list[i]!= file.response.url){
                this.picList.push(list[i])
              }
            }
          } else {
            console.info(file,fileList)
            var list = Object.assign([],this.picList)
            this.picList = []
            for(var i=0;i<list.length;i++){
              if(list[i]!= file.url){
                this.picList.push(list[i])
              }
            }
          }
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url
          this.dialogVisible = true
        },
        // 上传前对文件的大小的判断
        beforeAvatarUpload (file) {
          const isLt5M = file.size / 1024 / 1024 < 5
          if (!isLt5M) {
            this.$message.warning('上传图片大小不能超过 5 MB!')
          }
          return isLt5M
        },
        // 上传成功后的回调
        uploadSuccess (response, file, fileList) {
          this.picList.push(response.url)
          console.info(this.picList.toString())
        },
        // 上传错误
        uploadError (response, file, fileList) {
          this.$message.error(`上传失败，请重试！`)
        },
        handleRemove(file, fileList) {
          var thzs = this
          return this.$confirm("此操作将删除该回执单, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            thzs.toremove(file, fileList)
            return true
          });
        },
        uploadBackRecord(processId){
          this.fileList = []
          this.picList = []
          this.showUpload = true
          this.$nextTick(()=>{
            document.addEventListener('paste', this.onPasteUpload)
          })
          this.initPicList(processId)
        },
        initPicList(id){
          var query = {
            processId:id
          }
          getReceiptPicUrl(query).then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              if(!!res.picList && res.picList.length > 0){
                this.picList = res.picList
                for(var i=0;i<res.picList.length;i++){
                  var tmp = res.picList[i]
                  var obj = {
                    name:"回执单"+(i+1),
                    url:tmp
                  }
                  this.fileList.push(obj)
                }
              }
            }
          })
        },

        getUserName(){
          getUser().then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.applicationForm.user = res.user.id
            }
          })
        },
        getData(){
      //console.log(" this.applyObj.payType========>", this.applyObj.applylist)
      //console.log(" this.applyObj========>", this.applyObj)
          this.payType=''
          if (this.$refs.externalAccount && !this.$refs.externalAccount.baseComponent) {
            this.$refs.externalAccount.baseComponent = this.baseComponent ? this.$$parent : this.baseComponent
          }
          return new Promise((resolve, reject) => {
            this.applicationForm = {
              processId:null,
              dingjin:0,
              isApplyRecord:false,
              inter:{},
              exter:{
                businessType:null,
              },
              totalExterAmount:0,
              user:null,
              invoiceCompany:null,
              remark: null,
              textContent: '',
              fileList:[]
            }
            this.tableData = []
            if(this.applyObj){
              this.tableData = this.applyObj.applylist
              // this.applicationForm = Object.assign({},this.applyObj.application)
              this.applicationForm = this.applyObj.application
              this.applicationForm.deductPrice = 0
              this.applicationForm.dingjin = 0
              // this.applicationForm.textContent = ''
              this.$set(this.applicationForm,'textContent','')
              this.applicationForm.fileList = []
              this.applicationForm.exter = {
                businessType:null,
              }
              this.getUserName()
              this.deductList = this.applyObj.deductList
              var businessTypeList = []
              this.applicationForm.remark = ""
              this.payType = this.applyObj.payType
              var shipNameList = []

              const paymentGroupByLigangDateAndShipName = { };
              const paymentGroupByLigangDateAndShipName_zhouqi = { };
              const costAggIds = []
              for(var i=0;i<this.tableData.length;i++){
                var type=this.costTypeFmt(null,null,this.tableData[i].costTypeName,null)
                if(businessTypeList.indexOf(type)==-1){
                  businessTypeList.push(type)
                }
                if(this.tableData[i].dingjin){
                  this.applicationForm.dingjin += this.tableData[i].dingjin
                } else {
                  this.applicationForm.dingjin = 0
                }
                let key = '';
                if (this.applyObj.application.routeName == "applypayticketcar") {
                  console.log("this.tableData[i].businessType===>",this.tableData[i].businessType)
                  let time = '--';
                  let ship_name = this.tableData[i].shipName? this.tableData[i].shipName:'汽运直取';
                  // if (this.tableData[i].businessType == 20){
                  //   time = this.tableData[i].shipIntoTime? this.tableData[i].shipIntoTime:'暂无到港时间';
                  // }else {
                    time = this.tableData[i].epartureTimeDate? this.tableData[i].epartureTimeDate:'暂无离港时间';
                  // }
                  key = time+"/"+ship_name;
                }else {
                  key = (this.tableData[i].epartureTimeDate? this.tableData[i].epartureTimeDate:'暂无离港时间')+"/"+this.tableData[i].shipName;
                }


                if(!paymentGroupByLigangDateAndShipName[key]){
                  paymentGroupByLigangDateAndShipName[key] = this.NumFmt(null,null,this.tableData[i].settleAmount,null);

                  if (this.applyObj.application.routeName == "applypayticketshippay" && this.tableData[i].costTypeName == '运费') {
                    let paymentCycle = '/账期 --';
                    if(this.tableData[i].paymentCycle){
                      paymentCycle = '/账期 '+this.tableData[i].paymentCycle
                    }
                    paymentGroupByLigangDateAndShipName_zhouqi[key] = paymentCycle;
                  }


                  // shipNameList.push(this.tableData[i].shipName)

                  // var remark = (this.tableData[i].epartureTimeDate? this.tableData[i].epartureTimeDate:'暂无离港时间')+"/"+this.tableData[i].shipName+"/"+this.NumFmt(null,null,this.tableData[i].settleAmount,null)+"元;"
                  // this.applicationForm.remark += remark
                } else {
                  paymentGroupByLigangDateAndShipName[key] = paymentGroupByLigangDateAndShipName[key] + this.NumFmt(null,null,this.tableData[i].settleAmount,null);
                  // if (this.applyObj.application.routeName != "applypayticketcar") {
                  //   let paymentCycle = '/账期 --';
                  //   if(this.tableData[i].paymentCycle){
                  //     paymentCycle = '/账期'+this.tableData[i].paymentCycle
                  //   }
                  //   paymentGroupByLigangDateAndShipName_zhouqi[key] = paymentGroupByLigangDateAndShipName_zhouqi[key]+paymentCycle;
                  // }
                }
                if(this.tableData[i].id){
                  costAggIds.push(this.tableData[i].id)
                }
              }
              // 追加客户
              if (this.applyObj.application.routeName == "applypayticketfandian") {
                this.applicationForm.remark = `客户/${this.applyObj.application.customerName};`
              }

              if (this.applyObj.application.routeName == "applypayticket") {
                this.applicationForm.remark = `供应商/${this.applyObj.application.supplierNameShortName};`
              }
              Object.keys(paymentGroupByLigangDateAndShipName).forEach(key => {
                let remark = `${key}/${this.NumFmt(null,null,paymentGroupByLigangDateAndShipName[key],null)}元`
                if (this.applyObj.application.routeName == "applypayticketshippay" && paymentGroupByLigangDateAndShipName_zhouqi[key]) {
                  remark = remark + paymentGroupByLigangDateAndShipName_zhouqi[key];
                }
                remark = remark + ';'
                  this.applicationForm.remark += remark
              });

                if(this.applicationForm.additionalRemark){
                  this.applicationForm.remark = this.applicationForm.remark +this.applicationForm.additionalRemark+";"
                }
                if (businessTypeList && businessTypeList.length > 0) {
                  this.applicationForm.exter.businessType = businessTypeList.toString()
                }
              // this.applicationForm.totalExterAmount = 0
              // for(var i=0;i<this.tableData.length;i++){
              //   this.applicationForm.totalExterAmount += this.tableData[i].exterAmount
              // }

              if (this.applicationForm.remark == '' && this.applyObj.remark != '') {
                this.applicationForm.remark = this.applyObj.remark
              }

              for(var i=0;i<this.deductList.length;i++){
                var tmp = this.deductList[i]
                // this.applicationForm.deductPrice += Number(tmp.surplus)
                this.applicationForm.deductPrice += Number(tmp.totalPrice)
              }
              this.cleanComData()
              this.getCompinentData()
              this.setContractIds(this.applyObj.contractIds)
              this.loadFanDianInfo(costAggIds)
              this.loadHeTongInfo(costAggIds,this.payType)
            } else {
              this.payType = this.datas.params7
              this.setContractIds(this.datas.params9)
              var querydata = {
                paymentId:this.datas.params1,
                type:0
              }
              getPayment(querydata).then(res =>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                  this.applicationForm = res.obj
                  if (this.applicationForm && this.applicationForm.invoiceCompany) {
                    this.selecRreceiveCompany(this.applicationForm.invoiceCompany)
                  }
                  this.selectAccountById()
                  this.applicationForm.processId = this.datas && this.datas.processId
                  this.applicationForm.user = res.obj.createBy
                  this.applicationForm.isApplyRecord = true
                  this.applicationForm.textContent = this.datas.formValue.textContent
                  this.applicationForm.fileList = this.datas.formValue.fileList
                  this.applicationForm.exter = res.exter
                  const businessTypeBak = res.exter && res.exter.businessType;
                  this.applicationForm.accountingType = 0
                  if (this.datas.formValue && this.datas.formValue && this.datas.formValue.accountingType) {
                    this.applicationForm.accountingType = this.datas.formValue.accountingType
                  }
                  // this.applicationForm.inter = res.inter
                  this.applicationForm.price = 0
                  this.applicationForm.deductPrice = 0
                  this.applicationForm.dingjin = 0
                  this.applicationForm.totalExterAmount = 0
                  this.tableData = res.list
                  this.deductList =res.deduct
                  var businessTypeList = []
                  const costAggIds = []
                  for(var i=0;i<this.tableData.length;i++){
                    var tmp = this.tableData[i]
                    tmp.charge = tmp.amountDue - tmp.settleAmount
                    // this.applicationForm.totalExterAmount += tmp.exterAmount
                    var type=this.costTypeFmt(null,null,this.tableData[i].costTypeName,null)
                    if(businessTypeList.indexOf(type)==-1){
                      businessTypeList.push(type)
                    }
                    if(tmp.dingjin){
                      this.applicationForm.dingjin += tmp.dingjin
                    } else {
                      this.applicationForm.dingjin = 0
                    }
                    if(tmp.costAggregationId){
                      costAggIds.push(tmp.costAggregationId)
                    }
                  }
                  console.log('this.applicationForm===>',this.applicationForm)
                  if (businessTypeList && businessTypeList.length > 0) {
                    this.applicationForm.exter.businessType = businessTypeList.toString()
                  }

                  if (this.applicationForm.exter == null || this.applicationForm.exter.businessType == '') {
                    this.applicationForm.exter['businessType'] = businessTypeBak
                  }
                  for(var i=0;i<this.deductList.length;i++){
                    var tmp = this.deductList[i]
                    this.applicationForm.deductPrice += Number(tmp.totalPrice)
                  }
                  this.cleanComData()
                  this.getCompinentData()
                  this.loadFanDianInfo(costAggIds)
                  this.loadHeTongInfo(costAggIds,this.payType)
                }
              })
            }
            resolve(this.applicationForm)
          });

        },
        setContractIds(str) {
          if (!str) {
            return
          }
          this.contractIds = str.split(',')
        },
        getCompinentData() {
          if (this.$refs.externalAccount) {
            this.$refs.externalAccount.getData(this.applicationForm)
            this.$refs.externalAccount.setFormVale(this.datas && this.datas.formValue)
            this.$nextTick(()=>{
              this.checkedSettlement = this.$refs.externalAccount.sendData.checkedSettlement[0]
            })
          }
        },
        cleanComData(){
          this.$refs.externalAccount && this.$refs.externalAccount.cleandata()
        },
        getComponentsSendData(){
          var outData = this.$refs.externalAccount.sendData
          return outData
        },
        costTypeFmt(row,column,cellValue,index){
          return fmtDictionary(cellValue,this.dictionaryLists['cost_type']);
        },
        NumFmt(row,column,cellValue,index){
          var v = 0
          if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
            v = parseFloat(Math.abs(cellValue).toFixed(2))
          }
          return v
        },
      },
      components:{
        ExternalAccountRequest,
        'ElImageViewer': () => import('element-ui/packages/image/src/image-viewer')
      },
    }
</script>

<style scoped>
  .contract-image__preview {
    display: flex;
    flex-wrap: wrap;
  }
  .contract-image__preview >>> .el-image {
    margin: 0 5px 5px 0;
    flex: 1 48%;
    width: 200px;
    border: 1px solid #DCDCDC;
  }
  .contract-image__preview >>> .el-image:nth-of-type(even) {
    margin-right: 0;
  }
  .el-table-info >>> .cell{
    text-align: center;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }

  .xuanxiang >>> .el-dialog__body{
    padding: 10px 20px;
  }
  .hiddenClass >>> .el-upload {
    display: none;
  }

</style>
